var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiveaway(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80383 7.00033V11.1968C2.80383 11.5147 2.93002 11.8196 3.15469 12.0445C3.37936 12.2694 3.68411 12.3958 4.00199 12.3962H9.99866C10.3166 12.396 10.6215 12.2696 10.8463 12.0447C11.0711 11.8198 11.1974 11.5148 11.1974 11.1968V7.00033M4.03874 4.00258C3.51083 3.33116 3.40291 1.60449 5.20191 1.60449C7.24008 1.60449 6.97058 4.00258 7.00033 4.00258M7.00033 4.00258C7.03008 4.00258 6.79033 1.60449 8.79874 1.60449C10.5977 1.60449 10.4776 3.33116 9.95024 4.00258M7.00033 4.00258V12.3962M11.4967 4.00258H2.50399C2.00699 4.00258 1.60449 4.40508 1.60449 4.90208V6.10083C1.60449 6.59783 2.00699 7.00033 2.50399 7.00033H11.4967C11.9937 7.00033 12.3962 6.59783 12.3962 6.10083V4.90208C12.3962 4.40508 11.9937 4.00258 11.4967 4.00258Z",
    stroke: "#6E3004",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveaway);
export default __webpack_public_path__ + "static/media/giveaway.8e14b2cef04559c0915eb7046a97f22a.svg";
export { ForwardRef as ReactComponent };